import React from 'react';
import { SchemaGenerator } from '../../../components';

const schema = {
  table: 'SINCIK_WT01',
  rules: [{
    uuid: '08237fd4-c12f-4017-94c0-acba32da9a2e',
    cell: 'C',
    row: 1,
    column: '',
    formula: '',
  },
  {
    uuid: '9d9b0a2c-54ff-4803-87b7-62ff3c6ed01f',
    cell: 'B',
    row: 2,
    column: '',
    formula: '',
  },
  {
    uuid: '47bbfbdf-40a0-4809-89d2-fb99078fa1d3',
    cell: 'C',
    row: 2,
    column: '',
    formula: '',
  },
  {
    uuid: '6fed01c5-bdbc-4881-9bb8-d2a53f7ba01a',
    cell: 'B',
    row: 1,
    column: '',
    formula: '',
  },
  {
    uuid: '0d3fcbae-b834-4d61-a19c-77df35157404',
    cell: 'F',
    row: 1,
    column: '',
    formula: '',
  },
  {
    uuid: 'e9c66c20-1659-4630-aca0-a3dc8f56e865',
    cell: 'D',
    row: 2,
    column: '',
    formula: '',
  },
  {
    uuid: '882bec00-c44a-496b-b7ec-186bc9047b5f',
    cell: 'D',
    row: 3,
    column: '',
    formula: '',
  },
  {
    uuid: 'cdfb3c4a-c172-4871-a0b0-982777e05f25',
    cell: 'E',
    row: 1,
    column: '',
    formula: '',
  },
  {
    uuid: 'aa2e40fa-8c36-490b-a016-9b869bee56ac',
    cell: 'E',
    row: 3,
    column: '',
    formula: '',
  },
  {
    uuid: '62fec154-7514-4234-a22f-df40ba7b41f6',
    cell: 'F',
    row: 3,
    column: '',
    formula: '',
  },
  {
    uuid: '5343e896-23b4-4618-ba3f-b1de3ba5758f',
    cell: 'G',
    row: 1,
    column: '',
    formula: '',
  },
  {
    uuid: '7c98914b-1b92-434f-b6ef-42fae79e3d02',
    cell: 'G',
    row: 2,
    column: '',
    formula: '',
  },
  {
    uuid: '78bd29cf-2dfc-47c6-a983-e08cd136f30e',
    cell: 'G',
    row: 3,
    column: '',
    formula: '',
  },
  {
    uuid: '8f9fcaa2-b507-4f90-b94c-abd7fa13c2b1',
    cell: 'H',
    row: 1,
    column: '',
    formula: '',
  },
  {
    uuid: '7fe67412-d782-4b30-9790-90931e444ad8',
    cell: 'H',
    row: 2,
    column: '',
    formula: '',
  },
  {
    uuid: '7de8f572-5c58-4d73-b8c1-b7878103ae0a',
    cell: 'H',
    row: 3,
    column: '',
    formula: '',
  }],
};

class DevSchemaGenerator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      output1: {},
      output2: {},
    };

    this.outputUpdate1 = this.outputUpdate1.bind(this);
    this.outputUpdate2 = this.outputUpdate2.bind(this);
  }

  outputUpdate1(output1) {
    this.setState({ output1 });
  }

  outputUpdate2(output2) {
    this.setState({ output2 });
  }

  render() {
    return (
      <div>
        <section>
          <h4>Schema Generator</h4>
          <p>
            Herhangi bir parametre vermeden,
            varsayılan verilen ile oluşturulan Schema Generator örneği.
          </p>
          <SchemaGenerator
            // debug
            output={this.outputUpdate1}
            title="Schema Generator 1"
          />
          <pre>{JSON.stringify(this.state.output1, null, 2)}</pre>
        </section>
        <hr />
        <section>
          <h4>Schema Generator: Schema</h4>
          <p>Örnek bir şema ile oluşturulan Schema Generator örneği.</p>
          <SchemaGenerator
          // debug
            output={this.outputUpdate2}
            schema={schema}
            title="Schema Generator 2"
          />
          <pre>{JSON.stringify(this.state.output2, null, 2)}</pre>
        </section>
      </div>
    );
  }
}

export default DevSchemaGenerator;
